import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { BLOCCATI_PATH } from '@/lib/qsocials/bloccati';
import { useListBlockedQuery } from '@/services/socialApi';

/**
 * La riga «Account bloccati · N ›» in fondo al gruppo Privacy del tab Amici (punto 6, seconda
 * meta', L-2418 (a)): porta alla pagina del punto 7.
 *
 * Il NUMERO e' la lunghezza dell'elenco che il server ha mandato. Finche' la lettura non ha
 * risposto — o se e' fallita — la riga NON mostra un numero: «· 0» affermerebbe un dato che il
 * server non ha dato (stessa regola dei tab dei contatori). La query vive qui, non in
 * `Friends.tsx`: la riga monta solo dove monta il gruppo Privacy, quindi non c'e' una GET in piu'
 * fuori dal tab Amici.
 */
export function RigaAccountBloccati() {
  const { t } = useTranslation('general');
  const bloccati = useListBlockedQuery();
  const n = bloccati.data?.length;
  return (
    <Link
      to={BLOCCATI_PATH}
      data-testid="account-bloccati-link"
      className="flex min-h-[56px] items-center gap-3 border-t border-border px-4 py-2 text-sm font-semibold text-fg"
    >
      <span className="min-w-0 flex-1">
        {n === undefined
          ? t('social.blocked_title', { defaultValue: 'Blocked accounts' })
          : t('social.blocked_row_count', { n, defaultValue: 'Blocked accounts · {{n}}' })}
      </span>
      <ChevronRight aria-hidden className="h-4 w-4 shrink-0 text-fg-muted" />
    </Link>
  );
}
